import axios from 'axios';
import strings from '../common/strings'

export const http = axios.create({
    baseURL: strings.apiUrl,
    headers: {
        'Content-Type' : 'application/json',
        'accept' : '*/*'
    }
})